import { render, staticRenderFns } from "./Create-Job.vue?vue&type=template&id=a1c82fae&scoped=true"
import script from "./Create-Job.vue?vue&type=script&lang=js"
export * from "./Create-Job.vue?vue&type=script&lang=js"
import style0 from "./Create-Job.vue?vue&type=style&index=0&id=a1c82fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c82fae",
  null
  
)

export default component.exports